export default __webpack_public_path__ + "static/media/Arrows of the Bastion.0fa94f96.jpg";